@for (navItem of navItems; track $index) {
  @if (navItem.children?.length === 0) {
    <mat-list-item
      [routerLink]="navItem.route"
      appAccordionLink
      routerLinkActive="active-link"
      (click)="toggleItem(navItem.name)"
    >
      <span>
        <mat-icon class="icon-color">{{ navItem.icon }}</mat-icon>
        <h4 class="side-nav-item">{{ navItem.name | translate | titlecase }}</h4>
        @if (isMenuItemLoading(navItem.name)) {
          <mat-spinner diameter="16" class="menu-loading-spinner"></mat-spinner>
        }
      </span>
      <span>
        @if (navItem.name === 'dueList') {
          <app-ui-pill
            [number]="dueListWarningsExpiredSum"
            [expiredDueListWarnings]="true"
            class="due-list-pill"
          ></app-ui-pill>
        }
        @if (navItem.name === 'dueList') {
          <app-ui-pill
            [number]="dueListWarningsExpiringSum"
            [expiredDueListWarnings]="false"
            class="due-list-pill yellow-line"
          ></app-ui-pill>
        }
      </span>
    </mat-list-item>
  } @else {
    @if (isInAdmin || (!isInAdmin && navItem.name === 'usersAndPax')) {
      <mat-list-item
        [routerLink]="navItem.route"
        [class.active-link]="navItem === activeNavItem"
        (click)="closeSidenav()"
      >
        <mat-icon class="icon-color">{{ navItem.icon }}</mat-icon>
        <h4 class="side-nav-item">{{ navItem.name | translate | titlecase }}</h4>
        @if (isMenuItemLoading(navItem.name)) {
          <mat-spinner diameter="16" class="menu-loading-spinner"></mat-spinner>
        }
        <mat-icon class="dropdown-arrow">chevron_right</mat-icon>
      </mat-list-item>
    } @else {
      <mat-list-item (click)="toggleItem(navItem.name)" routerLinkActive="active-link">
        <mat-icon class="icon-color">{{ navItem.icon }}</mat-icon>
        <h4 class="side-nav-item">{{ navItem.name | translate | titlecase }}</h4>
        <mat-icon class="dropdown-arrow">chevron_right</mat-icon>
      </mat-list-item>
    }
  }
}
